module.exports = __webpack_public_path__ + "static/media/cw-brien.41c1e5b8.png";